/**
 * ตรวจว่าหน้านี้ถูกเปิดอยู่ใน native shell (apps/passenger-app) หรือในเบราว์เซอร์ธรรมดา
 *
 * ใช้ User-Agent ไม่ใช่ตัวแปรที่ inject เข้ามา เพราะ shell ตัวนี้ตั้งใจไม่มี bridge
 * (ADR 0001 D5) — `applicationNameForUserAgent` ของ react-native-webview ต่อ tag นี้
 * ท้าย UA ให้ตั้งแต่ก่อนหน้าแรกโหลด จึงไม่มีจังหวะกะพริบแบบการ inject ผ่าน JS
 *
 * ต้องเรียกฝั่ง client เท่านั้น (SSR ไม่มี navigator) — คืน false บน server
 */
export const APP_UA_TAG = "DeepTrackPassengerApp";

export function isNativeShell(): boolean {
  if (typeof navigator === "undefined") return false;
  return navigator.userAgent.includes(APP_UA_TAG);
}

/**
 * ปลายทางของปุ่ม "เปิดตั้งค่า" ตอนสิทธิ์ถูกปฏิเสธถาวร
 * - ในแอป: scheme `app-settings:` ที่ shell ดักไว้ใน decideLink → Linking.openSettings()
 * - ในเบราว์เซอร์: ไม่มี API ให้เปิดหน้าตั้งค่าได้ ต้องบอกผู้ใช้ให้ไปเปิดเอง
 */
export const APP_SETTINGS_URL = "app-settings:";
